import React from 'react';

import { Box } from '@mui/material';
import DataDisplay, {
  useResponsiveDataDisplayVariant,
} from '@sharedCR/coreDesignSystem/DataDisplay';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { PendingChangeKind } from 'constants/pendingChanges';

import { OVERVIEW_SKELETONS_LENGTH } from './PostClosing.constants';
import { getOverviewWrapperStyles, overviewCardStyles } from './PostClosingOverview.styles';

const OVERVIEW_SKELETON_ITEMS = Array.from({ length: OVERVIEW_SKELETONS_LENGTH });

const PostClosingOverview = ({ isLoading, overviewConfig }) => {
  const dataDisplayVariant = useResponsiveDataDisplayVariant();

  return (
    <Box
      sx={getOverviewWrapperStyles(isLoading ? OVERVIEW_SKELETONS_LENGTH : overviewConfig.length)}
    >
      {isLoading
        ? OVERVIEW_SKELETON_ITEMS.map((_, index) => (
            <Box key={index} sx={overviewCardStyles}>
              <DataDisplay isLoading title="" value="" variant={dataDisplayVariant} />
            </Box>
          ))
        : overviewConfig.map(({ name, value, icon, iconColor, changeKind, authors }) => (
            <Box key={name} sx={overviewCardStyles}>
              <DataDisplay
                changeKind={changeKind}
                icon={icon}
                iconColor={iconColor}
                pendingChangeAuthors={authors}
                title={name}
                value={value}
                variant={dataDisplayVariant}
              />
            </Box>
          ))}
    </Box>
  );
};

PostClosingOverview.propTypes = {
  ...WithLoadingPropTypes,
  overviewConfig: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      icon: PropTypes.node,
      iconColor: PropTypes.string,
      changeKind: PropTypes.oneOf(Object.values(PendingChangeKind)),
      authors: PropTypes.arrayOf(PropTypes.object),
    }),
  ),
};

export default PostClosingOverview;
